import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Typography,
  Stack,
  Button,
  LoadingButton,
} from "@altimateai/lego";
import { IconAlertTriangle } from "@tabler/icons-react";
import type { BaseUser } from "@/types";

interface Props {
  user: BaseUser | null;
  onOpenChange: (open: boolean) => void;
  onResolve: (action: "accept_sso" | "dismiss") => Promise<void>;
  isPending: boolean;
}

export const RoleConflictDialog = ({ user, onOpenChange, onResolve, isPending }: Props) => {
  return (
    <Dialog open={!!user} onOpenChange={onOpenChange}>
      <DialogContent className="al-max-w-md">
        <DialogHeader>
          <DialogTitle>
            <Stack direction="row" className="al-items-center al-gap-2">
              <IconAlertTriangle size={20} className="al-text-yellow-600" />
              Role Conflict
            </Stack>
          </DialogTitle>
        </DialogHeader>
        <div className="al-space-y-4">
          <Typography variant="body" className="al-text-sm al-text-muted-foreground">
            SSO group sync has determined a different role for <strong>{user?.email}</strong>.
          </Typography>

          <div className="al-grid al-grid-cols-2 al-gap-4">
            <div className="al-p-3 al-rounded al-border al-bg-gray-50">
              <Typography variant="body" className="al-text-xs al-text-muted-foreground al-mb-1">
                Current Role
              </Typography>
              <Typography variant="body" className="al-font-medium">
                {user?.role_title}
              </Typography>
            </div>
            <div className="al-p-3 al-rounded al-border al-border-yellow-200 al-bg-yellow-50">
              <Typography variant="body" className="al-text-xs al-text-muted-foreground al-mb-1">
                SSO Suggested Role
              </Typography>
              <Typography variant="body" className="al-font-medium">
                {user?.sso_resolved_role_title}
              </Typography>
            </div>
          </div>

          <Stack direction="row" className="al-justify-end al-gap-2 al-pt-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => onResolve("dismiss")}
              disabled={isPending}
            >
              Keep Current
            </Button>
            <LoadingButton size="sm" loading={isPending} onClick={() => onResolve("accept_sso")}>
              Apply SSO Role
            </LoadingButton>
          </Stack>
        </div>
      </DialogContent>
    </Dialog>
  );
};
